import { render, staticRenderFns } from "./MyIncidentApprovals.vue?vue&type=template&id=13300bea&"
import script from "./MyIncidentApprovals.vue?vue&type=script&lang=js&"
export * from "./MyIncidentApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports